import { ControlInlined } from '../control/control.model';
import {
    IRestrictedAccountObjectArgs,
    RestrictedAccountObject
} from '../restricted-account-object/restricted-account-object.model';

export interface IGroupArgs extends IRestrictedAccountObjectArgs {
    name?: string;
    title?: string;
    sequence?: number;
    scoreWeight?: number;
    includeInSummary?: boolean;
    controls?: Array<string> | Array<ControlInlined>;
    forms?: Array<string>;
    visibilityControl?: string;
    visibleIfEquals?: string;
}

const defaults = {
    name: '',
    title: '',
    sequence: 0,
    scoreWeight: 1,
    includeInSummary: true,
    controls: [],
    forms: [],
    visibilityControl: '',
    visibleIfEquals: ''
} as IGroupArgs;

abstract class AbstractGroup extends RestrictedAccountObject {
    name: string;
    title: string;
    sequence: number;
    scoreWeight: number;
    includeInSummary: boolean;
    controls: Array<string> | Array<ControlInlined>;
    forms: Array<string>;
    visibilityControl: string;
    visibleIfEquals: string;
}

export class Group extends AbstractGroup {
    controls: Array<string>;

    constructor(data?: IGroupArgs) {
        super({...defaults, ...data} as any);
    }
}

export class GroupInlined extends AbstractGroup {
    controls: Array<ControlInlined>;

    constructor(data?: IGroupArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/group/group.model.ts